<style scoped>
  .line{margin-bottom:25px}
  .text-key{text-align: right}
</style>
<template>
  <div>
    <Collapse simple :value="[1,2,3]">
      <Panel name="1">
        聘用人
        <div slot="content">
          <template v-for="(item,index) in client">
            <Row type="flex" align="middle">
              <Col span="20">
                <Row type="flex" align="middle" class="line">
                  <Col span="3" offset="1" class="text-key">身份类型<span style="color: red">*</span></Col>
                  <Col span="5" offset="1">
                    <Select v-model="item.identity" style="width:100px">
                      <Option v-for="item in identity" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </Col>
                  <Col span="3" offset="1" class="text-key">
                    名称<span style="color: red">*</span>
                  </Col>
                  <Col span="5" offset="1">
                    <Input v-model="item.name" placeholder="为便于利益审查，请务必准确完整填写"></Input>
                  </Col>
                </Row>
                <Row type="flex" align="middle" class="line" v-if="$route.query.detailed">

                  <Col span="3" offset="1" class="text-key">识别号码</Col>
                  <Col span="5" offset="1">
                    <Input v-model="item.IDCardCode" placeholder="身份证号/营业执照"></Input>
                  </Col>
                </Row>
              </Col>
              <Col span="4">
                <div style="cursor: pointer;color:#bbb" v-if="client.length>1" @click="client.splice(index,1)"><Icon type="md-close"/>删除</div>
                <div style="cursor: pointer;color:#bbb" v-if="index==client.length-1" @click="client.push({name:'',IDCardCode:'',litigation:'',})"><Icon type="md-add"/>新增聘用人</div>
                <!--<Button v-if="client.length>1" type="error" @click="client.splice(index,1)" icon="md-close">删除</Button>-->
              </Col>
            </Row>
            <Divider v-if="index!=client.length-1" :dashed="true"/>
          </template>
          <div style="text-align: right">
            <!--<Button type="success" style="width:80px" @click="client.push({name:'',IDCardCode:'',litigation:'',})" icon="md-add">增 加</Button>-->
          </div>
        </div>
      </Panel>
    </Collapse>
    <div style="padding:10px"></div>
    <div style="text-align: right"><Checkbox v-model="checkConflict" true-value="check" false-value="uncheck">利冲检索</Checkbox></div>
    <div style="padding:10px"></div>
    <Row :gutter="20" type="flex" justify="center">
      <Col span="4">
        <Button type="primary" style="width:100%" :disabled="true">上一步</Button>
      </Col>
      <Col span="4">
        <Button @click="nextStep()" type="primary" style="width:100%;">下一步</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
  export default {
    name: "step1",//基础信息填写
    props:{
      nextRoute:String,
    },
    data:function () {
      return{
        litigation:[
          {value:'plaintiff',label:'原告'},
          {value:'accused',label:'被告'},
        ],
        identity:[
          {value:'personal',label:'个人'},
          {value:'company',label:'单位'},
        ],
        checkConflict:'check',
      }
    },
    mounted:function(){
      this.getLitigationStatus()
    },
    methods:{
      nextStep:function () {
        this.$router.push({name:'litigationStep2',query:{id:this.$route.query.id,detailed:this.$route.query.detailed,checkConflict:this.checkConflict}})
      },
      getLitigationStatus:function () {
        var _this = this
        _this.send({
          headers:'C/ShowIdentity',
          success:function (res) {
            _this.identity = []
            for(var index in res.LitigantTypeTitle){
              _this.identity.push({
                type:res.LitigantTypeTitle[index].LitigantTypeNature,
                value:res.LitigantTypeTitle[index].LitigantTypeId,
                label:res.LitigantTypeTitle[index].LitigantTypeTitle}
              )
            }
            _this.litigation = []
            for(var index in res.LitigationLawsuit){
              _this.litigation.push({value:res.LitigationLawsuit[index].LitigationLawsuitId,label:res.LitigationLawsuit[index].LitigationLawsuitName})
            }
            _this.client.push({name:'',IDCardCode:'',litigation:'',})
          }
        })
      }
    },
    computed:{
      client:function () {
        return this.$store.state.project.create.step1.client
      },
      opposed:function () {
        return this.$store.state.project.create.step1.opposed
      },
    }
  }
</script>